import { GlobalApiResponse } from "app/core/models/apiResponse.interface";

export class ActionGetCustomer {
  static readonly type = "[CUSTOMER] GET CUSTOMERS";
  constructor(public payload: GlobalApiResponse) {}
}
